import { render } from "./DashboardReportList.vue?vue&type=template&id=02ed64f1&scoped=true"
import script from "./DashboardReportList.vue?vue&type=script&lang=js"
export * from "./DashboardReportList.vue?vue&type=script&lang=js"

import "./DashboardReportList.vue?vue&type=style&index=0&id=02ed64f1&scoped=true&lang=css"

import exportComponent from "/var/www/html/minty.crm.frontend.merchant/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02ed64f1"]])

export default __exports__